import { render, staticRenderFns } from "./TusFileDrop.vue?vue&type=template&id=3a58b6b2&scoped=true&"
import script from "./TusFileDrop.vue?vue&type=script&lang=ts&"
export * from "./TusFileDrop.vue?vue&type=script&lang=ts&"
import style0 from "./TusFileDrop.vue?vue&type=style&index=0&id=3a58b6b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a58b6b2",
  null
  
)

export default component.exports